// Un `DomainError` (`back/src/shared/domain/errors/DomainError.ts`) nunca incluye
// `statusCode` en el body; solo lo lleva un 500 real, generado por el handler por
// defecto de Fastify.
export const isServerError = (error: unknown): boolean =>
  typeof error === "object" &&
  error !== null &&
  "statusCode" in error &&
  typeof (error as Record<string, unknown>).statusCode === "number" &&
  (error as Record<string, number>).statusCode >= 500;
